import { html } from '@design.estate/dees-element';

export const demoFunc = () => html`
  <style>
    .demo-container {
      display: flex;
      flex-direction: column;
      gap: 24px;
      padding: 24px;
    }
    .demo-section {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    .demo-section h3 {
      margin: 0 0 8px 0;
      font-size: 14px;
      font-weight: 500;
      color: #888;
    }
    .demo-row {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      align-items: center;
    }
  </style>
  <div class="demo-container">
    <div class="demo-section">
      <h3>Basic Usage</h3>
      <div class="demo-row">
        <dees-form-submit>Submit Form</dees-form-submit>
        <dees-form-submit text="With Text Property"></dees-form-submit>
      </div>
    </div>

    <div class="demo-section">
      <h3>With Icons (inherited from DeesButton)</h3>
      <div class="demo-row">
        <dees-form-submit icon="lucide:send">Submit</dees-form-submit>
        <dees-form-submit icon="lucide:save" iconPosition="left">Save Form</dees-form-submit>
        <dees-form-submit icon="lucide:arrow-right" iconPosition="right">Continue</dees-form-submit>
      </div>
    </div>

    <div class="demo-section">
      <h3>Button Types</h3>
      <div class="demo-row">
        <dees-form-submit type="highlighted" icon="lucide:send">Highlighted</dees-form-submit>
        <dees-form-submit type="normal" icon="lucide:send">Normal</dees-form-submit>
        <dees-form-submit type="discreet" icon="lucide:send">Discreet</dees-form-submit>
      </div>
    </div>

    <div class="demo-section">
      <h3>Sizes</h3>
      <div class="demo-row">
        <dees-form-submit size="small" icon="lucide:send">Small</dees-form-submit>
        <dees-form-submit size="normal" icon="lucide:send">Normal</dees-form-submit>
        <dees-form-submit size="large" icon="lucide:send">Large</dees-form-submit>
      </div>
    </div>

    <div class="demo-section">
      <h3>States</h3>
      <div class="demo-row">
        <dees-form-submit status="normal" icon="lucide:send">Normal</dees-form-submit>
        <dees-form-submit status="pending" icon="lucide:send">Pending</dees-form-submit>
        <dees-form-submit status="success" icon="lucide:check">Success</dees-form-submit>
        <dees-form-submit status="error" icon="lucide:x">Error</dees-form-submit>
        <dees-form-submit disabled icon="lucide:send">Disabled</dees-form-submit>
      </div>
    </div>

    <div class="demo-section">
      <h3>In a Form Context</h3>
      <dees-form>
        <dees-input-text label="Name" key="name"></dees-input-text>
        <dees-input-text label="Email" key="email"></dees-input-text>
        <dees-form-submit icon="lucide:send" type="highlighted">Submit Form</dees-form-submit>
      </dees-form>
    </div>
  </div>
`;
